import { Directive, ElementRef, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[googleAddressAutoComplete]'
})
export class GooglePlacesDirective implements OnInit {
    @Input() placeholder: string = '';
    @Output() onSelectAddress: EventEmitter<any> = new EventEmitter();
    private autocomplete: google.maps.places.Autocomplete;

    constructor(
        private elementRef: ElementRef,
        private ngZone: NgZone
    ) { }

    ngOnInit() {
        this.elementRef.nativeElement.placeholder = this.placeholder;
        this.autocomplete = new google.maps.places.Autocomplete(
            this.elementRef.nativeElement,
            {
                types: ['address'],
                componentRestrictions: { country: ['ca'] }
            }
        );
        this.autocomplete.addListener('place_changed', () => {
            this.ngZone.run(() => {
                const place = this.autocomplete.getPlace();
                if (place.geometry) {
                    this.onSelectAddress.emit(place);
                }
            });
        });
    }
}